// ------------------------------------
// Import SCSS files
// ------------------------------------
import "../sass/singles.scss";

// ------------------------------------
// Scripts
// ------------------------------------

import "./components/header";
import "./components/slider";
import "./components/input-number-stepper";
